import React from "react";
import styled from "../style.module.css";

// Sticky in-page nav — jumps to a section anchor. `items` = [{ id, label }].
const StickyNav = ({ items }) => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <nav className={styled.stickyNav}>
      {items.map((it) => (
        <button key={it.id} type="button" className={styled.stickyNavBtn} onClick={() => go(it.id)}>
          {it.label}
        </button>
      ))}
    </nav>
  );
};

export default StickyNav;
